module.exports = __webpack_public_path__ + "img/ext-link-arrow-light.47518318.svg";